import { render, staticRenderFns } from "./PasswordResetConfirmation.vue?vue&type=template&id=377201d6&scoped=true&"
import script from "./PasswordResetConfirmation.vue?vue&type=script&lang=js&"
export * from "./PasswordResetConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetConfirmation.vue?vue&type=style&index=0&id=377201d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377201d6",
  null
  
)

export default component.exports